import { AsyncPipe, NgTemplateOutlet, UpperCasePipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { InstrumentDetailFacade } from '@zero/instrument-details/domain';
import { CopyToClipboardComponent, DividerComponent, IconComponent, PillComponent } from '@zero/shared/ui-web-design-system';
import { DerivativeDataPayoutProfileComponent } from '../derivative-data-payout-profile/derivative-data-payout-profile.component';

@Component({
  selector: 'instrument-details-derivative-data',
  imports: [
    AsyncPipe,
    DividerComponent,
    IconComponent,
    NgTemplateOutlet,
    TranslocoPipe,
    CopyToClipboardComponent,
    PillComponent,
    UpperCasePipe,
    DerivativeDataPayoutProfileComponent,
  ],
  templateUrl: './derivative-data.component.html',
  styleUrls: ['./derivative-data.component.scss'],
})
export class DerivativeDataComponent {
  public readonly facade = inject(InstrumentDetailFacade);
}
